
































import { computed, defineComponent, reactive } from '@vue/composition-api';
import { useStore } from '@/components/composables/useStore';
import { Store } from 'vuex';
import { RootState } from '@/store/Store';

interface Props {
  total: number;
  storePath: string;
}

interface State {
  page: number;
  rowsPerPage: number;
}

const Component = defineComponent({
  name: 'Pagination',
  props: {
    total: Number,
    storePath: String,
  },
  setup(props: Props) {
    const store: Store<RootState> = useStore();

    const state = reactive({
      page: computed({
        get(): number {
          return store.getters[`${props.storePath}/queryPage`] || 1;
        },
        set(newVal: number) {
          store.dispatch(`${props.storePath}/setQueryPage`, newVal);
        },
      }),
      rowsPerPage: computed({
        get(): number {
          return store.getters[`${props.storePath}/queryRowsPerPage`] || 20;
        },
        set(newVal: number) {
          store.dispatch(`${props.storePath}/setQueryRowsPerPage`, newVal);
        },
      }),
    }) as State;

    function totalPages() {
      if (!props.total) return 0;
      return (
        Math.floor(props.total / state.rowsPerPage) +
        (props.total % state.rowsPerPage ? 1 : 0)
      );
    }
    function getDropdownItems() {
      return [
        { value: 20, text: '20' },
        { value: 50, text: '50' },
        { value: 100, text: '100' },
      ];
    }

    return {
      state,
      totalPages,
      getDropdownItems,
    };
  },
});
export default Component;
